import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-5" }
const _hoisted_2 = { class: "grid gap-3 sm:grid-cols-2" }

import { InputRow, SectionHeader, Combobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import type { User } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyBasisForm',
  props: {
    form: {},
    keepersEmployees: {},
    loadingKeepersEmployees: { type: Boolean }
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SectionHeader), null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('companies.information')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "name",
        label: "companies.form.name"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "name",
            modelValue: _ctx.form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
            autocomplete: "name",
            placeholder: _ctx.$t('companies.form.name')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "cvr",
        label: "companies.form.cvr"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "cvr",
            modelValue: _ctx.form.cvr,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.cvr) = $event)),
            autocomplete: "name",
            placeholder: _ctx.$t('companies.form.cvr')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "address",
        label: "companies.form.address"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "address",
            modelValue: _ctx.form.address,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.address) = $event)),
            autocomplete: "address",
            placeholder: _ctx.$t('companies.form.address')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "postal_code",
        label: "companies.form.postal_code"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "postal_code",
            modelValue: _ctx.form.postal_code,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.postal_code) = $event)),
            autocomplete: "postal_code",
            placeholder: _ctx.$t('companies.form.postal_code')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "city",
        label: "companies.form.city"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "city",
            modelValue: _ctx.form.city,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.city) = $event)),
            autocomplete: "city",
            placeholder: _ctx.$t('companies.form.city')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "country",
        label: "companies.form.country"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "country",
            modelValue: _ctx.form.country,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.country) = $event)),
            autocomplete: "country",
            placeholder: _ctx.$t('companies.form.country')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "email",
        label: "companies.form.email"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "email",
            modelValue: _ctx.form.email,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.email) = $event)),
            autocomplete: "email",
            placeholder: _ctx.$t('companies.form.email')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "telephone",
        label: "companies.form.telephone"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "telephone",
            modelValue: _ctx.form.telephone,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.telephone) = $event)),
            autocomplete: "name",
            placeholder: _ctx.$t('companies.form.telephone')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "mobile_number",
        label: "companies.form.mobile_number"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "mobile_number",
            modelValue: _ctx.form.mobile_number,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.mobile_number) = $event)),
            autocomplete: "name",
            placeholder: _ctx.$t('companies.form.mobile_number')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "fax_number",
        label: "companies.form.fax_number"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "fax_number",
            modelValue: _ctx.form.fax_number,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.fax_number) = $event)),
            autocomplete: "name",
            placeholder: _ctx.$t('companies.form.fax_number')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "roger_invoices",
        label: "companies.form.roger_invoices"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "roger_invoices",
            modelValue: _ctx.form.roger_invoices,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.roger_invoices) = $event)),
            autocomplete: "name",
            placeholder: _ctx.$t('companies.form.roger_invoices')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "roger_receipts",
        label: "companies.form.roger_receipts"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "roger_receipts",
            modelValue: _ctx.form.roger_receipts,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.roger_receipts) = $event)),
            autocomplete: "name",
            placeholder: _ctx.$t('companies.form.roger_receipts')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "keepers_email",
        label: "companies.form.keepers_email"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "keepers_email",
            modelValue: _ctx.form.keepers_email,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.keepers_email) = $event)),
            autocomplete: "name",
            placeholder: _ctx.$t('companies.form.keepers_email')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "employee_default_id",
        label: "companies.form.primary_employee"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Combobox), {
            modelValue: _ctx.form.employee_default_id,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.employee_default_id) = $event)),
            options: _ctx.keepersEmployees,
            placeholder: _ctx.$t('companies.form.primary_employee'),
            loading: _ctx.loadingKeepersEmployees,
            "label-by": "name",
            "value-by": "id"
          }, null, 8, ["modelValue", "options", "placeholder", "loading"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "assistant_id",
        label: "companies.form.assistant_id"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Combobox), {
            modelValue: _ctx.form.assistant_id,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.assistant_id) = $event)),
            options: _ctx.keepersEmployees,
            placeholder: _ctx.$t('companies.form.assistant_id'),
            loading: _ctx.loadingKeepersEmployees,
            "label-by": "name",
            "value-by": "id"
          }, null, 8, ["modelValue", "options", "placeholder", "loading"])
        ]),
        _: 1
      }, 8, ["form"])
    ])
  ]))
}
}

})